// StepOne.js
import React from "react";
import { useTranslation } from "react-i18next";               // 🆕 i18n import

function StepOne({
  formData,
  formErrors,
  touched,
  validUserError,
  handleChange,
  handleBlur,
}) {
  const { t } = useTranslation("register");                   // 🆕 namespace

  return (
    <>
      <div className="first-last-unique">
        <div className="form-group-unique">
          <label htmlFor="firstName">{t("stepOne.labels.firstName")}</label>
          <input
            type="text"
            id="firstName"
            name="firstName"
            value={formData.firstName}
            onChange={handleChange}
            onBlur={handleBlur}
          />
          {touched.firstName && formErrors.firstName && (
            <p className="error">{formErrors.firstName}</p>
          )}
        </div>
        <div className="form-group-unique">
          <label htmlFor="familyName">{t("stepOne.labels.familyName")}</label>
          <input
            type="text"
            id="familyName"
            name="familyName"
            value={formData.familyName}
            onChange={handleChange}
            onBlur={handleBlur}
          />
          {touched.familyName && formErrors.familyName && (
            <p className="error">{formErrors.familyName}</p>
          )}
        </div>
      </div>

      <div className="form-group-unique">
        <label htmlFor="company">{t("stepOne.labels.company")}</label>
        <input
          type="text"
          id="company"
          name="company"
          value={formData.company}
          onChange={handleChange}
          onBlur={handleBlur}
        />
        {touched.company && formErrors.company && (
          <p className="error">{formErrors.company}</p>
        )}
      </div>

      <div className="form-group-unique">
        <label htmlFor="commercialRecord">{t("stepOne.labels.commercialRecord")}</label>
        <input
          type="text"
          id="commercialRecord"
          name="commercialRecord"
          value={formData.commercialRecord}
          onChange={handleChange}
          onBlur={handleBlur}
        />
        {touched.commercialRecord && formErrors.commercialRecord && (
          <p className="error">{formErrors.commercialRecord}</p>
        )}
      </div>

      <div className="form-group-unique">
        <label htmlFor="taxNumber">{t("stepOne.labels.taxNumber")}</label>
        <input
          type="text"
          id="taxNumber"
          name="taxNumber"
          value={formData.taxNumber}
          onChange={handleChange}
          onBlur={handleBlur}
        />
        {touched.taxNumber && formErrors.taxNumber && (
          <p className="error">{formErrors.taxNumber}</p>
        )}
      </div>
    </>
  );
}

export default StepOne;
